import { environment } from '../../../environments/environment';
import { ProtectedResourceScopes } from '@azure/msal-angular';

export const msalInterceptorConfig = new Map<string, Array<string | ProtectedResourceScopes> | null>()
  .set(environment.apiConfig.IdentityAPI.endpoint, [
    {
      httpMethod: 'POST',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'PUT',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'GET',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'DELETE',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'PATCH',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
  ])
  .set(environment.apiConfig.corporateAPI.endpoint, [
    {
      httpMethod: 'POST',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'PUT',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'GET',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'DELETE',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
    {
      httpMethod: 'PATCH',
      scopes: [...environment.msalConfig.token_scopes.write],
    },
  ]);
